import type { ISettingMaster } from "@bbj-types/setting";
import { Typography } from "@mui/material";
import { getActionDate, getActionLabel, isActionLate } from "@root/utils/actions";
import { useI18nContext } from "@root/utils/organisation";
import clsx from "clsx";
import type { MouseEvent } from "react";
import type { TPaperCandidateChallengeAction } from "../types";
import { PaperCandidateChallengeActionIcon } from "./icon";
import { PaperCandidateChallengeActionCardRoot, paperCandidateChallengeActionCardClasses } from "./styles";

export interface IPaperCandidateChallengeActionCardProps<Action extends TPaperCandidateChallengeAction> {
  action: Action;
  actionTypes?: ISettingMaster["values"];
  actionChannels?: ISettingMaster["values"];
  onClick?: (event: MouseEvent, action: Action) => void;
}

export const PaperCandidateChallengeActionCard = <Action extends TPaperCandidateChallengeAction>({
  action,
  actionTypes,
  actionChannels,
  onClick,
}: IPaperCandidateChallengeActionCardProps<Action>) => {
  const { timeZone } = useI18nContext();
  const actionLate = isActionLate(action, timeZone);

  return (
    <PaperCandidateChallengeActionCardRoot
      className={clsx(paperCandidateChallengeActionCardClasses.root, {
        [paperCandidateChallengeActionCardClasses.todo]: action.status === "todo" && !actionLate,
        [paperCandidateChallengeActionCardClasses.done]: action.status === "done",
        [paperCandidateChallengeActionCardClasses.late]: action.status === "todo" && actionLate,
        [paperCandidateChallengeActionCardClasses.missed]: action.status === "missed",
      })}
      onClick={(evt) => onClick?.(evt, action)}
      disabled={!onClick}
    >
      <PaperCandidateChallengeActionIcon action={action} actionChannels={actionChannels} />
      <Typography variant="body2SemiBold">
        {getActionLabel(action, actionTypes)} -{" "}
        {getActionDate(action)?.toLocaleString("fr-FR", { day: "numeric", month: "short", timeZone })}
      </Typography>
    </PaperCandidateChallengeActionCardRoot>
  );
};
